module.exports = __webpack_public_path__ + "d156019a48060514f1f03f3e626b67a8.svg";